
import { defineComponent, ref } from "vue";
import { doiJiko } from "./common";
export default defineComponent({
  setup() {
    const isDoiJikoDialogVisible = ref(false); //同意事項ダイアログ表示制御変数
    const doiJikoContent = ref(doiJiko);
    return {
      isDoiJikoDialogVisible,
      doiJikoContent,
    };
  },
});
